import React from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
`;

const Tab = styled.div`
  padding: 15px 20px;
  cursor: pointer;
  font-weight: ${props => props.$active ? 'bold' : 'normal'};
  color: ${props => props.$active ? '#0084ff' : '#333'};
  border-bottom: ${props => props.$active ? '2px solid #0084ff' : 'none'};
  
  &:hover {
    background-color: ${props => props.$active ? 'transparent' : '#f5f5f5'};
  }
`;

const TabsHeader = ({ activeTab, onTabChange, userRole }) => {
  // Only show admin and documents tabs to admin users
  const isAdmin = userRole === 'admin';
  
  return (
    <TabsContainer>
      <Tab 
        $active={activeTab === 'chat'} 
        onClick={() => onTabChange('chat')}
      >
        Chat
      </Tab>
      
      {isAdmin && (
        <>
          <Tab 
            $active={activeTab === 'documents'} 
            onClick={() => onTabChange('documents')}
          >
            AI Controls
          </Tab>

          <Tab
            $active={activeTab === 'admin'}
            onClick={() => onTabChange('admin')}
          >
            Admin
          </Tab>
        </>
      )}
    </TabsContainer>
  );
};

export default TabsHeader;
